import { render } from "./CashBook.vue?vue&type=template&id=0d635403&scoped=true"
import script from "./CashBook.vue?vue&type=script&lang=js"
export * from "./CashBook.vue?vue&type=script&lang=js"

import "./CashBook.vue?vue&type=style&index=0&id=0d635403&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d635403"]])

export default __exports__